import { VerificationCodeType } from "@overmap-ai/common"
import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { openLogin, sdk, untilPageUnloads } from "src/sdk"
import { EmailVerificationView } from "src/views/EmailVerificationView/EmailVerificationView"
import { z } from "zod"

const verifyEmailSearchSchema = z.object({
	code: z.string().optional(),
})

export const Route = createFileRoute("/verify-email")({
	component: EmailVerificationView,
	validateSearch: zodValidator(verifyEmailSearchSchema),
	loaderDeps: ({ search }) => ({ code: search.code }),
	loader: async ({ deps }) => {
		const { code } = deps

		if (!code) {
			openLogin("/")
			return untilPageUnloads()
		}

		const verificationCode = await sdk.emailVerifications.getVerificationCode(code)

		if (verificationCode.verification_type === VerificationCodeType.APPLICATION_INVITE) {
			return verificationCode
		}

		await sdk.emailVerifications.validateVerificationCode(code, undefined)

		// Verified. Signing in happens on the API's login page.
		openLogin("/")
		return untilPageUnloads()
	},
})
